// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
/**
 * Lazy loader for premium plan dev view instantiator
 */ export const premiumPlanInstantiateLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-premiumplan-instantiate" */ "../PremiumPlanViewAdaptor/premiumPlanViewInstantiate"));
/**
 * Lazy loader for premium plan dev view renderer
 */ export const premiumPlanRenderLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-premiumplan-render" */ "../PremiumPlanViewAdaptor/premiumPlanViewRender")).then((bundle)=>{
        return bundle.premiumPlanViewRenderer;
    });
export const LazyPremiumPlanView = /*#__PURE__*/ lazy(()=>premiumPlanRenderLoader().then((mod)=>{
        return {
            default: ()=>mod.render({
                    modalLayerHostId: "modalLayerHostId"
                })
        };
    }));
